import styled from 'styled-components'
import { mobileL } from '../../../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const WrapperHeaderOnboarding = styled.div`
  .timeline {
    max-width: ${(props) => props.config.width};
    width: 100%;
    height: 50px;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    margin: auto;
    ${mobileL({
      display: 'none',
    })}
  }
`
export const Dot = styled.div`
  position: relative;
  width: ${(props) => props.config.dotSize};
  height: ${(props) => props.config.dotSize};
  border-radius: 50%;
  background-color: ${(props) =>
    props.idx > props.activeStep ? '#6c757d2b' : 'var(--border)'};
  transition: all ease 300ms;
  cursor: pointer;

  &:not(:last-child)::after {
    content: '';
    display: block;
    // (Width - dotWidth * dotCount) / (dotCount - 1)
    width: ${(props) =>
      `calc((${props.config.width} - ${props.config.dotSize} * ${props.config.stepCount}) 
      / (${props.config.stepCount} - 1) )`};

    transition: all ease 300ms;
    transform: translate(15px, 7px);
    height: 2px;
    background-color: ${(props) =>
      props.idx + 1 > props.activeStep ? '#6c757d2b' : 'var(--border)'};
  }

  .label-step {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 12px);
    white-space: nowrap;
  }
`
